import { Tooltip } from '@mui/material';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import { getScorePerformanceByValue } from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import clsx from 'clsx';

const EcovadisScoreDetail = ({ score, value }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.scoreDetail}>
      <div
        className={clsx(classes.scoreValue, getScorePerformanceByValue(value))}
      >
        <span>{value}</span>/100
      </div>
      <span className={classes.scoreLabel}>
        {i18next.t(`ecovadis.scores.${score}`)}
      </span>
      <Tooltip
        title={i18next.t(`ecovadis.scoresTooltips.${score}`)}
        placement="top"
        arrow
      >
        <span className={classes.scoreInfoIcon}>
          <EAIcon icon="info-rounded" />
        </span>
      </Tooltip>
    </div>
  );
};

export default EcovadisScoreDetail;
